window.initProjectRequest = function () {
    const inputs = document.querySelectorAll('.project-request__input');

    return {
        step: 1,
        totalSteps: 4,
        submitting: false,
        submitted: false,
        errors: {},
        serverError: '',

        validated: [],
        successMessages: {
            fullname: 'Klingt super, danke!',
            company: 'Ist notiert!',
            email: 'Alles klar, passt!',
            phone: 'Perfekt, danke dir!',
            services: 'Gute Wahl!',
            servicesMultiple: 'Spannender Projektmix!'
        },

        data: {
            fullname: '',
            company: '',
            phone: '',
            email: '',
            services: [],
            costs: {
                min: 5000,
                current: 50000,
                max: 150000,
            },
            deadline: 50,
            color: 50,
            message: '',
        },

        serviceOptions: [
            { value: 'Website / App', icon: 'website' },
            { value: 'Printmaterialien', icon: 'print' },
            { value: 'Markenaufbau', icon: 'branding' },
            { value: 'Beratung / Konzept', icon: 'consulting' }
        ],

        formatMoney(value) {
            return new Intl.NumberFormat('de-DE').format(value);
        },

        get selectedServicesText() {
            if (this.data.services.length === 0) {
                return 'Keine Bereiche ausgewählt';
            }
            return this.data.services.join(', ');
        },

        validateField(field) {
            this.validated = this.validated.filter(f => f !== field);

            // 1. FULLNAME
            if (field === 'fullname') {
                const nameValue = this.data.fullname ? this.data.fullname.trim() : '';
                const hasForbiddenChars = /[^\p{L}\s]/u.test(nameValue);

                if (!nameValue) {
                    this.errors.fullname = 'Bitte verrate uns deinen Namen.';
                } else if (nameValue.length < 2) {
                    this.errors.fullname = 'Dein Name ist etwas zu kurz.';
                } else if (hasForbiddenChars) {
                    this.errors.fullname = 'Bitte verwende nur Buchstaben und Leerzeichen.';
                } else {
                    delete this.errors.fullname;
                }
            }

            // 2. COMPANY
            if (field === 'company') {
                const companyValue = this.data.company ? this.data.company.trim() : '';

                if (!companyValue) {
                    this.errors.company = 'Bitte gib dein Unternehmen an.';
                } else if (companyValue.length < 2) {
                    this.errors.company = 'Der Name des Unternehmens ist etwas zu kurz.';
                } else {
                    delete this.errors.company;
                }
            }

            // 3. EMAIL
            if (field === 'email') {
                const emailValue = this.data.email ? this.data.email.trim() : '';

                if (!emailValue) {
                    this.errors.email = 'Bitte gib deine E-Mail-Adresse an.';
                } else {
                    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

                    if (!emailRegex.test(emailValue)) {
                        this.errors.email = 'Diese E-Mail-Adresse sieht nicht ganz richtig aus.';
                    } else {
                        delete this.errors.email;
                    }
                }
            }

            // 4. PHONE
            if (field === 'phone') {
                const phoneValue = this.data.phone ? this.data.phone.trim() : '';

                if (phoneValue) {
                    const phoneRegex = /^[0-9+\s\-()\/]{5,30}$/;
                    if (!phoneRegex.test(phoneValue)) {
                        this.errors.phone = 'Bitte gib eine gültige Telefonnummer an.';
                    } else {
                        delete this.errors.phone;
                    }
                } else {
                    delete this.errors.phone;
                }
            }

            if (!this.errors[field]) {
                if (field !== 'phone' || (field === 'phone' && this.data.phone.trim() !== '')) {
                    this.validated.push(field);
                }
            }
        },

        validateStep(step) {
            this.errors = {};
            this.serverError = '';

            if (step === 1) {
                this.validateField('fullname');
                this.validateField('company');
                this.validateField('email');
                this.validateField('phone');
            }

            if (step === 2) {
                if (this.data.services.length === 0) {
                    this.errors.services = 'Bitte wähle mindestens einen Bereich aus.';
                    this.validated = this.validated.filter(f => f !== 'services');
                } else {
                    delete this.errors.services;
                    if (!this.validated.includes('services')) {
                        this.validated.push('services');
                    }
                }
            }

            return Object.keys(this.errors).length === 0;
        },

        next() {
            if (!this.validateStep(this.step)) return;
            if (this.step < this.totalSteps) this.step++;
        },

        prev() {
            if (this.step > 1) this.step--;
        },

        async submitForm() {
            if (!this.validateStep(this.totalSteps)) return;

            this.submitting = true;
            this.errors = {};
            this.serverError = '';

            try {
                const response = await fetch('/wp-json/projektanfrage/v1/send', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(this.data)
                });

                const result = await response.json();

                if (response.ok) {
                    this.submitted = true;
                } else if (response.status === 422) {
                    this.errors = result.errors || {};

                    // Jump at the beginning of the form if there are validation errors
                    this.step = 1;
                } else {
                    this.serverError = result.message || 'Es ist ein Serverfehler aufgetreten. Bitte versuche es später noch einmal.';
                }
            } catch (error) {
                this.serverError = 'Verbindung fehlgeschlagen. Bitte überprüfe deine Internetverbindung.';
                console.error('Request Error:', error);
            } finally {
                this.submitting = false;
            }
        }
    };
};